<template>
  <a-spin tip="加载中..." :spinning="loading">
  <div class="center-box">

      <div class="searchBox">
          <a-space  class=" mr-10">
              <a-input class="keyword"  allowClear v-model:value="queryParams.searchKey"  @pressEnter="changePage"
                  placeholder="请输入关键字" />
          </a-space>
          <a-button  type="primary" @click="changePage">查询</a-button>
      </div>

      <a-table :data-source="waylinesData.data" align="center" class="mt10" :pagination="paginationProp" row-key="id"  @change="refreshData">
              <a-table-column  align="center" key="name" title="航线名称" data-index="name" />
              <a-table-column  align="center" key="payload_model_keys" title="负载" data-index="payload_model_keys" >
                <template #default="{ record }">
                    {{ record.payload_model_keys.toString() }}
                  </template>
                </a-table-column>
              <a-table-column  align="center" key="update_time" title="更新时间" data-index="update_time" >
                <template #default="{record}">
                    {{ moment(record.update_time).format('YYYY-MM-DD HH:mm:ss') }}
                  </template>
              </a-table-column>
              <a-table-column  align="center" key="active" title="操作" >
                <template #default="{record}">
                  <a-button class="btnLink" type="link" @click="openBinding(record)">绑定算法</a-button>
                </template>
              </a-table-column>
      </a-table>
      <a-modal
          v-model:visible="isOpenAlgorithm"
          width="fit-content"
          style="min-height:40vh ;"
          @ok="bindingAlgorithm"
          @cancel="cancelBinding"
          :maskClosable="false"
          :confirmLoading="isBindingLoading"
        >
        <div style="padding: 30px 0;" class="cf">
          <div class="flex-display flex-justify-between flex-align-center mb10">
            <h3 class="cf">算法模型添加</h3>
            <a-button type="primary" @click="addModel">添加模型</a-button>
          </div>
          <a-space class="mr-20">
            <span>跳帧数量:</span>
              <a-input-number v-model:value="skipFrame" :min="1"/>帧
          </a-space>
          <a-space class="mr-20">
            <span>推送频率:</span>
              <a-input-number v-model:value="pushFrequency" :min="1"/>秒
          </a-space>
          <a-space  class="mr-20">
            <span>置信度:</span>
              <a-input-number v-model:value="confThreshold" :min="0.01" :max="0.99" :step="0.01"/>
          </a-space>
          <a-space>
            <span>启用AI盒子:</span>
            <a-checkbox v-model:checked="isGdd"></a-checkbox>
          </a-space>
          <a-descriptions class="mt20" bordered v-for="(taskItem,index) in taskList.data" :key="index" layout="vertical" :column="7">
            <a-descriptions-item label="模型名称：">
              <a-select
                  ref="select"
                  v-model:value="taskItem.model_no"
                  :disabled="taskItem.taskNo"
                  style="width: 140px"
                >
                  <a-select-option  v-for="item in modelList" :key="item.modelNo" :value="item.modelNo" :title="item.name">{{ item.name }}</a-select-option>
              </a-select>
            </a-descriptions-item>
            <a-descriptions-item label="开始算法航点">
              <a-select
                  v-model:value="taskItem.start_point_index"
                  style="width: 100px"
                >
                  <a-select-option  v-for="item in waylineList" :key="item" :value="item">{{ item }}</a-select-option>
              </a-select>
            </a-descriptions-item>
            <a-descriptions-item label="结束算法航点">
              <a-select
                  v-model:value="taskItem.end_point_index"
                  style="width: 100px"
                >
                  <a-select-option  v-for="item in waylineList" :key="item" :value="item">{{ item }}</a-select-option>
              </a-select>
            </a-descriptions-item>
            <a-descriptions-item label="动作绑定" :span="2">
              <a-select
                  @change="(v:[])=>changeAction(v,taskItem)"
                  v-model:value="taskItem.actions"
                  mode="multiple"
                  style="width:fit-content;min-width: 162px;color: #333"
              >
                <a-select-option  v-for="item in aiList" :key="item.id" :value="item.id">{{ item.name }}</a-select-option>
              </a-select>
            </a-descriptions-item>
            <a-descriptions-item label="选择音频">
              <a-select
                  :disabled="!taskItem.actions?.includes('VOICE')"
                  v-model:value="taskItem.file_id"
                  style="width: 150px;"
              >
                <a-select-option  v-for="item in audioList" :key="item.file_id" :value="item.file_id">{{ item.file_title }}</a-select-option>
              </a-select>
            </a-descriptions-item>
            <a-descriptions-item >
              <a-button type="danger"  @click="deleteModel(index,taskItem.id)">
                <template #icon>
                  <DeleteOutlined />
                </template>
              </a-button>
              </a-descriptions-item>
          </a-descriptions>
        </div>

        </a-modal>

  </div>
</a-spin>
</template>

<script lang="ts" setup>
import { ref, onMounted, reactive, computed } from 'vue'
import { getWaylineFiles, getWaylineLngLat } from '/@/api/wayline'
import { ELocalStorageKey } from '/@/types'
import { WaylineFile, taskListType } from '/@/types/wayline'
import {
  getAlgorithmModelListPageVo,
  bindingAiAlgorithm,
  getWayLineAiBindingDetail,
  getAudioFileList
} from '/@/api/manage'
import coordtransform from 'coordtransform'// 坐标转换
import moment from 'moment'
import { message, Pagination } from 'ant-design-vue'
import {
  DeleteOutlined
} from '@ant-design/icons-vue'
const queryParams = ref({
  page_num: 1,
  page_size: 10,
  algorithm_type: null,
  searchKey: null
})
const paginationProp = reactive({
  showQuickJumper: false,
  showSizeChanger: false,
  page_size: 10,
  current: 1,
  total: 0
})
const workspaceId = localStorage.getItem(ELocalStorageKey.WorkspaceId)!
const waylinesData = reactive({
  data: [] as WaylineFile[],
})
const taskList = reactive({
  data: [] as taskListType[],
})
const isOpenAlgorithm = ref(false)
const modelList = ref([])
const waylineInfo = ref()
const waylineList = ref([])
const audioList = ref([])
const aiList = ref([
  { id: 'VOICE', name: '语音喊话' },
  { id: 'PHOTO', name: '拍照' },
  { id: 'FLASH', name: '红蓝爆闪' },
  { id: 'IR', name: '探照灯' },
])
const loading = ref(false)
const pushFrequency = ref(15)
const skipFrame = ref(3)
const confThreshold = ref(0.5)
const algorithm_source = ref<'dksl' | 'gdd'>('dksl')
const isGdd = computed({
  get: () => algorithm_source.value === 'gdd',
  set: (val: boolean) => {
    algorithm_source.value = val ? 'gdd' : 'dksl'
  }
})
const isBindingLoading = ref(false)
onMounted(() => {
  getList()
  getModelList()
  getAudio()
})
function getAudio () {
  getAudioFileList(workspaceId, { page: 1, page_size: 999 }).then(res => {
    if (res.code === 0) {
      audioList.value = res.data.list
    }
  })
}
function changeAction (value:string[], taskItem:object) {
  if (!value.includes('VOICE') && taskItem.file_id) {
    taskItem.file_id = ''
  }
}
function cancelBinding () {
  isOpenAlgorithm.value = false
  taskList.data = []
  skipFrame.value = 3
  pushFrequency.value = 15
  confThreshold.value = 0.5
}
function deleteModel (index:number, id:number) {
  taskList.data.forEach((el, indexEl) => {
    if (indexEl === index) {
      taskList.data.splice(indexEl, 1)
    }
  })
}
function getModelList () {
  getAlgorithmModelListPageVo({
    page_num: 1,
    page_size: 99,
    algorithm_type: null,
    searchKey: null,
    workspace_id: workspaceId
  }).then(res => {
    if (res.code === 0) {
      modelList.value = res.data.list
    }
  })
}
function getBindingAlgorithm (flyLineId:string) {
  const userId = localStorage.getItem(ELocalStorageKey.UserId)
  taskList.data = []
  getWayLineAiBindingDetail({
    // user_id: userId || '',
    fly_line_id: flyLineId
  }).then(res => {
    if (res.code === 0) {
      if (res.data.list.length > 0) {
        confThreshold.value = res.data.list[0].conf_threshold
        pushFrequency.value = res.data.list[0].push_frequency
        algorithm_source.value = res.data.list[0].algorithm_source
        skipFrame.value = res.data.list[0].skip_frame
        res.data.list.forEach(item => {
          taskList.data.push({
            model_no: item.model_no,
            modelInfo: [],
            start_point_index: item.start_point_index,
            end_point_index: item.end_point_index,
            actions: JSON.parse(item.actions ?? '[]') ?? [],
            file_id: item.file_id,
          })
        })
      }
    }
  })
}
function bindingAlgorithm () {
  const userId = localStorage.getItem(ELocalStorageKey.UserId)
  const list:any = []
  for (const item of taskList.data) {
    item.modelInfo = []
    for (const elModel of modelList.value) {
      if (item.model_no === elModel.modelNo) {
        item.modelInfo.push({
          model_name: elModel.name,
          model_no: elModel.modelNo,
          algorithm_source: algorithm_source.value
        })
      }
    }
    list.push({
      start_point_index: item.start_point_index,
      end_point_index: item.end_point_index,
      model_list: item.modelInfo,
      actions: item.actions,
      file_id: item.file_id,
    })
    if (item.actions?.includes('VOICE') && !item.file_id) {
      message.warning('请选择音频文件')
      return
    }
  }
  isBindingLoading.value = true
  bindingAiAlgorithm({
    user_id: userId,
    fly_line_id: waylineInfo.value.id,
    skip_frame: skipFrame.value,
    push_frequency: pushFrequency.value,
    conf_threshold: confThreshold.value,
    waypoint_algorithm_list: list
  }).then(res => {
    if (res.code === 0) {
      isOpenAlgorithm.value = false
      taskList.data = []
      skipFrame.value = 3
      pushFrequency.value = 15
      confThreshold.value = 0.5
      message.success('绑定算法成功')
    }
  }).finally(() => {
    isBindingLoading.value = false
  })
}
function addModel () {
  taskList.data.push({
    model_no: '',
    modelInfo: [],
    start_point_index: 1,
    end_point_index: waylineList.value.length
  })
}
function openBinding (wayline:any) {
  loading.value = true
  waylineInfo.value = wayline
  getWaylineLngLat(workspaceId, waylineInfo.value.id).then(res => {
    loading.value = false
    if (res.code === 0) {
      isOpenAlgorithm.value = true
      waylineList.value = []
      if (res.data.waylines.length === 0) {
        waylineList.value = []
      } else {
        const num = res.data.waylines.length
        for (let i = 1; i <= num; i++) {
          waylineList.value.push(i)
        }
      }
    }
  })
  getBindingAlgorithm(waylineInfo.value.id)
}
function changePage () {
  queryParams.value.page_num = 1
  getList()
}
function refreshData (page:any) {
  queryParams.value.page_num = page.current
  getList()
}
function getList () {
  getWaylineFiles(workspaceId, {
    page: queryParams.value.page_num,
    page_size: queryParams.value.page_size,
    order_by: 'update_time desc',
  })
    .then((res) => {
      if (res.code !== 0) {
        return
      }
      waylinesData.data = [...res.data.list]
      paginationProp.total = res.data.pagination.total
      paginationProp.current = res.data.pagination.page
    })
}
</script>

<style lang="scss" scoped>
.btnLink{
  margin: 0;
  padding: 0;
  height: fit-content;
}
</style>
